import { Chip } from "@mui/material";
import { QuestStatusValue } from "@quest_editor/constants";
import { getQuestStatusOptions } from "@quest_editor/utils/view/constLabels";

type ChipColor =
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning";

const statusColorMap: Record<QuestStatusValue, ChipColor> = {
  created: "success",
  request_waiting: "warning",
  waiting: "error",
  in_progress: "info",
  done: "default",
  suspended: "default",
  closed: "default",
};

const QuestStatusChip = ({ status }: { status: QuestStatusValue }) => {
  const questStatuses = getQuestStatusOptions();
  const label = questStatuses.find((qs) => qs.value === status)?.label ?? status;
  const color = statusColorMap[status] || "default";

  return <Chip label={label} color={color} size="small" />;
};

export default QuestStatusChip;
